<div class="auroraPagination">
	<ul class="navbar-right pagination" style="margin: 0;">
		<li [ngClass]="pagination.isOnFirstPage() ? ['disabled'] : ['']"
			(click)="pagination.goToFirstPage()"><a href="#"
			title="D&eacute;but" onclick="return false;">&laquo;</a></li>
		<li [ngClass]="pagination.isOnFirstPage() ? ['disabled'] : ['']"
			(click)="pagination.goToPreviousPage()"><a href="#"
			title="Pr&eacute;c&eacute;dent" onclick="return false;">&lt;</a></li>
		<li class="active"><a href="#" title="" onclick="return false;">{{pagination.display()}}</a>
		</li>
		<li [ngClass]="pagination.isOnLastPage() ? ['disabled'] : ['']"
			(click)="pagination.goToNextPage()"><a href="#" title="Suivant"
			onclick="return false;">&gt;</a></li>
		<li [ngClass]="pagination.isOnLastPage() ? ['disabled'] : ['']"
			(click)="pagination.goToLastPage()"><a href="#" title="Fin"
			onclick="return false;">&raquo;</a></li>
	</ul>
	<div class="navbar-right">&nbsp;&nbsp;</div>
	<div class="navbar-right"
		[hidden]="!pagination.canDisplayChoicesForNbItemsPerPage">

		<select class="form-control" name="paginationNbItemsPerPage"
			id="paginationNbItemsPerPage"
			[(ngModel)]='pagination.choiceNbItemsPerPage'
			(change)="pagination.updateNbItemsPerPage()">

			<option *ngFor="let choice of pagination.choicesForNbItemsPerPage" [ngValue]="choice">{{choice.libelle}}</option>
		</select>
	</div>
</div>